import React, { useContext } from 'react';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';

import {
    NavContext,
    NavRoutes
} from '../contexts';

import {
    ApiPage,
    WidgetPage
} from '../pages';

export const Routes = ({ ...props }) => {
    const { menuItems } = useContext(NavContext);

    return (

        <Switch>
            {menuItems && menuItems.map((item, index) => {
                return <Route key={index} exact path={item.routePath} component={item.component} />
            })}
            <Route exact path={NavRoutes.WidgetMap} component={WidgetPage} />
            <Route exact path={NavRoutes.Api} component={ApiPage} />
        </Switch>
    );
}